import React, { useState, useEffect } from "react";
import AdminDashboard from "../../AdminDashboard";
import { isAuthenticated } from "../../../../auth"
import { listGiftTypes } from "../../apiAdmin";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { default_url } from "../../../../index"
import { dict } from "../../../../dictionary";
import { Link, useHistory } from "react-router-dom";


const GiftTypes = (props) => {
    let history = useHistory();
    const [data, setData] = useState([{}]);
    const [deletedItem, setDeletedItem] = useState({
        name: "",
        id: ""
    });
    const [show, setShow] = useState(false);

    const { user, token } = isAuthenticated();

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = (event) => {
        setShow(true);
        setDeletedItem({ name: event.target.name, id: event.target.id })
    }
    const handleDelete = (event) => {
        event.preventDefault();
        handleClose();
        window.location.href = (default_url + "admin/gift-types/delete?gift_type_id=" + deletedItem.id)
    }

    useEffect(() => {
        async function fetchData() {
            await listGiftTypes(user._id, token)
                .then(res => {
                    setData(res);
                })
        }
        fetchData();
    }, []);

    const clickSubmit = (event) => {
        event.preventDefault();
        history.push(default_url + "admin/gift-types/create")
    }

    const showAlert = () => {
        if (props.location.state) {
            let msg = ""
            switch (props.location.state.prevPath) {
                case "create": msg = props.location.state.error ? props.location.state.error : dict["new_gift_type_has_been_created"]; break;
                case "delete": msg = props.location.state.error ? props.location.state.error : dict["gift_type_has_been_deleted"]; break;
                case "edit": msg = props.location.state.error ? props.location.state.error : dict["gift_type_has_been_updated"]; break;
                default: msg = "";
            }
            return (
                <div
                    className={"alert " + ((props.location.state && props.location.state.error) ? "alert-danger" : "alert-info") + " alert-dismissible fade show"}
                    role="alert"
                >
                    <h2 style={{ textAlign: "start" }}>{msg}</h2>
                    <button type="button" className="close alertCloseBtn" data-dismiss="alert" aria-label="Close" style={{ left: default_url == "/ar/" ? "0" : "auto", right: default_url == "/ar/" ? "auto" : "0" }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            )
        }
    }

    const popUp = () => {
        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{dict["deleting_gift_type"]}</Modal.Title>
                </Modal.Header>
                {
                    default_url == "/en/" && <Modal.Body style={{ textAlign: "start" }}>{"Are you sure you want to delete " + deletedItem.name + "?"}</Modal.Body>
                }
                {
                    default_url == "/ar/" && <Modal.Body style={{ textAlign: "start" }}>{"هل انت متأكد تريد حذف " + deletedItem.name + "؟"}</Modal.Body>
                }
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        {dict["close"]}
                    </Button>
                    <Button variant="primary" onClick={handleDelete}>
                        {dict["delete"]}
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

    const allTypes = () => {
        return (
            data && data.length > 0 &&
            data.sort((a, b) => a.value - b.value).map((item, index) => {
                return (
                    <div key={index} className={"dataContainer " + (index === data.length - 1 ? "lastDataContainer" : "")}>
                        <span className="dataContainerTitle" style={{ float: default_url == "/en/" ? "left" : "right" }}>{item.name}</span>
                        <a className="dataContainerAction"
                            href="#"
                            onClick={handleShow}
                            name={item.name}
                            id={item._id}
                            style={{ float: default_url == "/en/" ? "right" : "left" }}
                        >{dict["delete"]}</a>
                        {popUp()}
                        <Link className="dataContainerAction" to={default_url + "admin/gift-types/edit?gift_type_id=" + item._id} style={{ float: default_url == "/en/" ? "right" : "left" }}>{dict["edit"]}</Link>
                    </div>
                )
            })
        )
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showAlert()}
                <h3 className="formContainerTitle">{dict["gift_types"]}</h3>
                {allTypes()}
                <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["add_new_gift_type"]}</button>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="222"
            data={form}
            categories={data}
            subcategories={[]}
        />
    )
}

export default GiftTypes;